<img #map src="{{locationURL}}" *ngIf="locationURL">